import { GHLLanguageKeys as e } from "./ghl-ui.es273.js";
import o from "./ghl-ui.es707.js";
const m = {
  name: e.englishUS,
  locale: o
};
export {
  m as date_en_US
};
